import createApiFromState from 'api/createApiFromState';
import { actions as preferencesActions } from 'reducers/preferencesReducer';

const { initialisePreferences, setPreference } = preferencesActions;

function createPreferencesMiddleware() {
  let hasInitialised = false;

  return ({ dispatch, getState }) =>
    (next) =>
    async (action) => {
      const state = getState();
      const api = createApiFromState({ dispatch, getState });

      if (!hasInitialised && state.auth.isLoggedIn) {
        hasInitialised = true;
        try {
          const response = await api.get('/api/preferences/list');
          dispatch(initialisePreferences(response.data));
        } catch {
          // A 403 here means the session is being torn down: the api
          // interceptor has already dispatched reauthRequired (→ redirect to
          // login). Swallow it so a teardown response does not surface as an
          // unhandled rejection (Rollbar noise) on the way out.
        }
      }

      next(action);

      if (action.type === setPreference.toString()) {
        try {
          await api.post('/api/preferences/set', {
            property: action.payload.key,
            preference: action.payload.value,
          });
        } catch {
          // As above — session teardown is already handled by the interceptor.
        }
      }
    };
}

export default createPreferencesMiddleware;
